/**
 * Y2K CLUB — Free Gift v6
 * Le bonnet Flammes Rouges est ajouté automatiquement au panier dès que le
 * sous-total (hors bonnet offert) atteint 100 €, et retiré s'il repasse en dessous.
 * Il est visible dans le tiroir panier, à 0 € grâce à la réduction automatique BXGY.
 * v7 : pause pendant le Black Friday (27/11 00h00 → 30/11 23h59, heure de Paris) :
 * pas de bonnet ajouté, bonnet déjà présent retiré, barre de progression masquée.
 */
(function () {
  'use strict';
  if (window.__Y2K_FREE_GIFT_INIT__) return;
  window.__Y2K_FREE_GIFT_INIT__ = true;

  var GIFT_VARIANT_ID = 48437096710489;
  var GIFT_THRESHOLD_CENTS = 10000;
  var PROP = '_y2k_free_gift';
  var PAUSE_FROM = Date.UTC(2026, 10, 26, 23, 0, 0);  // 27/11/2026 00:00 Paris
  var PAUSE_TO   = Date.UTC(2026, 10, 30, 23, 0, 0);  // 01/12/2026 00:00 Paris
  function paused() { var n = Date.now(); return n >= PAUSE_FROM && n < PAUSE_TO; }
  if (paused()) {
    var st = document.createElement('style');
    st.id = 'y2k-gift-pause';
    st.textContent = '[data-cart-message],.cart-message{display:none!important}';
    (document.head || document.documentElement).appendChild(st);
  }
  var busy = false, timer = null, internal = 0;
  var nativeFetch = window.fetch.bind(window);

  function cartJSON() { internal++; return nativeFetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); }).finally(function () { internal--; }); }
  function post(url, body) {
    internal++;
    return nativeFetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); }).finally(function () { internal--; });
  }
  function giftLine(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (it.variant_id === GIFT_VARIANT_ID && it.properties && it.properties[PROP]) return it;
    }
    return null;
  }
  function subtotalExGift(cart) {
    var t = 0;
    cart.items.forEach(function (it) { if (!(it.variant_id === GIFT_VARIANT_ID && it.properties && it.properties[PROP])) t += it.original_line_price; });
    return t;
  }
  function refreshDrawer() {
    var c = document.querySelector('cart-element');
    if (c && typeof c.getCart === 'function') { try { c.getCart(); } catch (e) {} }
  }
  function sync() {
    if (busy) return Promise.resolve();
    busy = true;
    return cartJSON().then(function (cart) {
      var line = giftLine(cart), sub = subtotalExGift(cart);
      if (paused()) {
        if (line) return post('/cart/change.js', { id: line.key, quantity: 0 }).then(refreshDrawer);
        return;
      }
      if (sub >= GIFT_THRESHOLD_CENTS && !line) {
        var p = {}; p[PROP] = 'true';
        return post('/cart/add.js', { items: [{ id: GIFT_VARIANT_ID, quantity: 1, properties: p }] }).then(refreshDrawer);
      }
      if (line && (sub < GIFT_THRESHOLD_CENTS || line.quantity !== 1)) {
        return post('/cart/change.js', { id: line.key, quantity: sub < GIFT_THRESHOLD_CENTS ? 0 : 1 }).then(refreshDrawer);
      }
    }).catch(function () {}).finally(function () { busy = false; });
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(sync, 350); }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch(input, init);
    if (!internal && /\/cart\/(add|change|update|clear)(\.js)?/.test(url)) { p.then(schedule, schedule); }
    return p;
  };
  ['theme:cart:added', 'theme:cart:update', 'theme:cart:loaded'].forEach(function (ev) { document.addEventListener(ev, schedule); });
  document.addEventListener('submit', function (e) { var f = e.target; if (f && f.action && /\/cart/.test(f.action)) schedule(); }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule); else schedule();

  // Sécurité au moment du paiement : on s'assure que le panier est à jour avant de partir.
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button[name="checkout"], [name="checkout"], .cart__checkout');
    if (!b || b.dataset.y2kGiftOk) return;
    e.preventDefault(); e.stopImmediatePropagation();
    sync().then(function () { b.dataset.y2kGiftOk = '1'; b.click(); setTimeout(function () { delete b.dataset.y2kGiftOk; }, 2000); });
  }, true);
})();
